import React from 'react';

const toneClasses = {
  loading: 'border-blue-400 text-blue-100 bg-blue-950/40',
  error: 'border-red-400 text-red-100 bg-red-950/40',
  empty: 'border-yellow-400 text-yellow-100 bg-yellow-950/40',
  info: 'border-slate-400 text-slate-100 bg-slate-900/40',
};

export function StatusMessage({
  title,
  message,
  tone = 'info',
  actionLabel,
  onAction,
}) {
  const role = tone === 'error' ? 'alert' : 'status';
  const ariaLive = tone === 'error' ? 'assertive' : 'polite';

  return (
    <section
      role={role}
      aria-live={ariaLive}
      className={`rounded-lg border p-4 text-center ${toneClasses[tone] || toneClasses.info}`}
    >
      <h2 className="text-xl font-semibold">{title}</h2>
      {message && <p className="mt-2">{message}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-4 rounded-md bg-yellow-400 px-4 py-2 font-semibold text-slate-950 hover:bg-yellow-300 focus:outline-none focus:ring-2 focus:ring-yellow-100"
        >
          {actionLabel}
        </button>
      )}
    </section>
  );
}
